<template lang="pug">
    .shopping-cart(:class="theClass")
        gmh-shopping-cart(
            :settings="settings"
            :translations="translations"
        )
            template(slot="cart-footer")
                div
            template(slot="cart-submit-button-container")
                div
            template(slot="cart-submit-button-container")
                div
        
        template(v-if="listView")
            button-control.shopping-cart__display-mobile(v-if="visibleCartItemsCount" @click="goToPayment") Pay now
</template>

<script>
import ReMiniCart from 'utils/vue/components/complex/cart/re-mini-cart/script.js'

export default {
    name: 'shopping-cart-page',

    mixins: [
        ReMiniCart,
    ],

    data() { return {
        settings: {
            components: {
                "cart-list": "gmh-cart-list",
                "cart-billing": "gmh-cart-billing",
                "cart-empty": "gmh-cart-empty",
            },
            "cart-billing": {
                form: {
                    addressBox: {
                        show: false,
                    },
                    fields: {
                        zip: {
                            show: false,
                            validations: false,
                        },
                    },
                },
            },
            "cart-final": {
                print: {
                    showButton: false,
                },
                showConfirmationMessage: false,
            },
        },
        translations: {
            "cart-billing": {
                title: "Checkout",
                note: " ",
                form: {
                    fields: {
                        card: {
                            label: 'Card Number',
                        },
                        cvv: {
                            label: 'CVV code',
                        },
                    },
                },
                submitButtonTitle: 'Pay Now',
                saveCardLabel: 'Save this card for quicker checkout on future purchases.',
            },
            "cart-final": {
                title: '<img src="/images/client/got-me-hookd/cart-final-icon.svg">',
                subTitle: 'Thank you!',
                notice: 'Your order has been successfully paid.',
            },
        },
    }},

    computed: {
        view() {
            return this.$route.meta.cartView
        },

        listView() {
            return this.view == 'list'
        },

        theClass() {
            return {
                [`shopping-cart--${this.view}-view`]: true,
                'shopping-cart--empty': !this.visibleCartItemsCount,
            }
        },
    },

    watch: {
        visibleCartItemsCount(val) {
            if (!val && !this.listView) {
                this.$router.back()
            }
        },
    },

    methods: {
        goToPayment() {
            this.$router.push('/cart/payment')
        },
    },
}
</script>
